<template>
  <div>
    <simplebar class="table-area">
      <b-table
          ref="keywordTable"
          striped
          hover
          :empty-text="$t('components.bootstrap_table.empty_text')"
          :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
          show-empty
          :fields="fields"
          :items="keywords.suggestions"
          :stacked="$store.state.app.isMobile"
      >
        <template v-slot:cell(value)="data">
          <div class="keyword-container">
            <marked-text :content="data.item.value" :keyword="keyword"></marked-text>
            <div>
              <b-btn class="p-1 mx-1" variant="light" v-clipboard:copy="data.item.value">
                <i class="mdi mdi-content-copy"></i>
              </b-btn>
              <b-btn class="p-1" variant="light" @click="handleSelectKeyword(data.item.value)"
                     v-if="!keywordList.includes(data.item.value)"
                     :disabled="keywordList.length > 10"
              >
                <i class="mdi mdi-plus-circle-outline"></i>
              </b-btn>
              <b-btn v-else class="p-1" variant="danger" @click="handleRemoveKeyword(data.item.value)">
                <i class="mdi mdi-delete"></i>
              </b-btn>
            </div>
          </div>
        </template>

        <template v-slot:cell(historical_data.keyword_info.search_volume)="data">
          <span v-if="data.value">{{ data.value | numberFormat }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(historical_data.keyword_info.monthly_searches)="data">
          <div v-if="data.value">
            <keyword-trend-chart :chartData="data.value"/>
          </div>
          <span v-else>-</span>
        </template>


        <template v-slot:cell(historical_data.keyword_info.cpc)="data">
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(historical_data.keyword_info.competition_level)="data">
          <div v-if="data.value">
            <h5>
            <span :class="`badge badge-${competitionOptions[data.value.toLowerCase()].color}`">
                  {{ competitionOptions[data.value.toLowerCase()].text }}
            </span>
            </h5>
          </div>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(details)="row">
          <b-btn @click="showDetailModal(row.item)" variant="primary" size="sm" :disabled="!row.item.historical_data">
            <i class="mdi mdi-eye-outline"></i>
            {{ $t('pages.keyword.table.show_details') }}
          </b-btn>
        </template>
      </b-table>
    </simplebar>
    <keyword-detail-modal :historicalData="selectedKeywordHistory"></keyword-detail-modal>
  </div>
</template>

<script>
import KeywordDetailModal from "./KeywordDetailModal";
import KeywordTrendChart from "./KeywordTrendChart";
import MarkedText from "./Widget/MarkedText";
import {keywordMethods, keywordComputed} from "@/state/helpers";
import simplebar from "simplebar-vue";

export default {
  name: "KeywordTable",
  components: {MarkedText, KeywordTrendChart, KeywordDetailModal, simplebar},
  props: ['keywords', 'keyword'],
  data() {
    return {
      fields: [
        {key: 'value', sortable: false, label: this.$t('pages.keyword.table.fields.keyword')},
        {
          key: 'historical_data.keyword_info.search_volume',
          sortable: false,
          label: this.$t('pages.keyword.table.fields.search_volume'),
          class: 'text-center'
        },
        {
          key: 'historical_data.keyword_info.monthly_searches',
          sortable: false,
          label: this.$t('pages.keyword.table.fields.trend'),
          class: 'text-center trend-col'
        },
        {
          key: 'historical_data.keyword_info.cpc',
          sortable: false,
          label: this.$t('pages.keyword.table.fields.average_cpc'),
          class: 'text-center'
        },
        {
          key: 'historical_data.keyword_info.competition_level',
          sortable: false,
          label: this.$t('pages.keyword.table.fields.competition'),
          class: 'text-center'
        },
        {key: 'details', sortable: false, label: this.$t('pages.keyword.table.fields.details'), class: 'text-end'}
      ],
      loading: true,
      competitionOptions: {
        low: {
          color: 'success',
          text: this.$t('pages.keyword.table.competitions.LOW')
        },
        medium: {
          color: 'warning',
          text: this.$t('pages.keyword.table.competitions.MEDIUM')
        },
        high: {
          color: 'danger',
          text: this.$t('pages.keyword.table.competitions.HIGH')
        }
      },
      selectedKeywordHistory: null,
    }
  },
  computed: {
    ...keywordComputed
  },
  methods: {
    ...keywordMethods,
    showDetailModal(item) {
      this.selectedKeywordHistory = item.historical_data

      this.$bvModal.show('keyword-detail-modal')
    },
    handleSelectKeyword(keyword) {
      this.addKeyword(keyword)
    },
    handleRemoveKeyword(keyword) {
      this.removeKeyword(keyword)
    }
  }
}
</script>

<style scoped>
.keyword-container {
  display: flex;
  justify-content: space-between;
}

@media (min-width: 768px) {
  /deep/ .trend-col {
    max-width: 140px !important;
  }
}

.table-area {
  height: 600px;
}

</style>